<ng-template #PartList>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div style="max-width: 1200px; width: 100%; height: auto; margin: 0 auto; background: #fff">
                <div nxLayout="grid maxwidth">
                    <div nxRow>
                        <div nxCol="12">
                            <h3 nxHeadline="subsection-medium" class="title">
                                {{ 'b2b.documents.document-detail' | translate }} {{ partnerDocument.dms2shortNote }}
                            </h3>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <p>
                                <b>{{ 'b2b.documents.policy-number' | translate }}:</b>
                                {{ partnerDocument.dms2shortNote }}
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <p>
                                <b>{{ 'b2b.documents.type' | translate }}:</b>
                                {{ partnerDocument.dms2docBrandLabel }}
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <p>
                                <b>{{ 'b2b.documents.category' | translate }}:</b>
                                {{ partnerDocument.dms2docCategoryLabel }}
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <p>
                                <b>{{ 'b2b.documents.status' | translate }}:</b>
                                {{ partnerDocument.dms2processStatusLabel }}
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <div class="scroll-container">
                                <table nxTable nxSort (sortChange)="sortTable($event)">
                                    <thead>
                                        <tr nxTableRow>
                                            <th nxHeaderCell nxSortHeaderCell="createTs">
                                                {{ 'b2b.documents.created-at' | translate }}</th>
                                            <th nxHeaderCell nxSortHeaderCell="lastChangedTs">
                                                {{ 'b2b.documents.updated-at' | translate }}</th>
                                            <th nxHeaderCell nxSortHeaderCell="dms2numPz">
                                                {{ 'b2b.documents.policy-number' | translate }}</th>
                                            <th nxHeaderCell nxSortHeaderCell="dms2shortNote">
                                                {{ 'b2b.documents.original-file-name' | translate }}
                                            </th>
                                            <th nxHeaderCell>{{ 'b2b.documents.type' | translate }}</th>
                                            <th nxHeaderCell>{{ 'b2b.documents.category' | translate }}</th>
                                            <th nxHeaderCell>{{ 'b2b.documents.status' | translate }}</th>
                                            <th nxHeaderCell>{{ 'b2b.documents.document-download' | translate }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr nxTableRow *ngFor="let item of partnerDocumentListPage">
                                            <td nxTableCell>{{ item.createTs | dateFormat }}</td>
                                            <td nxTableCell>{{ item.lastChangedTs | dateFormat }}</td>
                                            <td nxTableCell>{{ item.dms2numPz }}</td>
                                            <td nxTableCell longText>{{ item.dms2shortNote }}</td>
                                            <td nxTableCell>{{ item.dms2docBrandLabel }}</td>
                                            <td nxTableCell>{{ item.dms2docCategoryLabel }}</td>
                                            <td nxTableCell>{{ item.dms2processStatusLabel }}</td>
                                            <td nxTableCell>
                                                <nx-link>
                                                    <a href="{{ documentDownloadUrl(partnerDocument.dms2numPz, item.itemId) }}"
                                                        target="_blank">
                                                        <nx-icon name='download'></nx-icon>
                                                        {{'b2b.documents.download' | translate}}
                                                    </a>
                                                </nx-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div nxRow class="nx-margin-top-s">
                                <div nxCol="12" class="justify-end">
                                    <nx-pagination class="pagination" [count]="partnerDocumentList.length" [page]="page"
                                        type="advanced" [perPage]="elementsPerPage" (goPrev)="prevPage()"
                                        (goNext)="nextPage()" (goPage)="goToPage($event)">
                                    </nx-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>